import DOMPurify from "dompurify";
export function sanitizeInput(dirtyInput) {
    const cleanInput = DOMPurify.sanitize(dirtyInput, { ALLOWED_TAGS: [] });
    return cleanInput;
}
